import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronLeftMiniIcon, ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
const buttonCss = "b9zgkvv";
const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);
const Navigation = ({
  backwardDisabled = false,
  forwardDisabled = false,
  onBackward,
  onForward
}) => <div>
    <Button onClick={onBackward} disabled={backwardDisabled} aria-label={I18n.t('booking.templates.go_to_previous_month')}>
      <ArrowChevronLeftMiniIcon size="large" />
    </Button>
    <Button onClick={onForward} disabled={forwardDisabled} aria-label={I18n.t('booking.templates.go_to_next_month')}>
      <ArrowChevronRightMiniIcon size="large" />
    </Button>
  </div>;
Navigation.propTypes = {
  backwardDisabled: PropTypes.bool,
  forwardDisabled: PropTypes.bool,
  onBackward: PropTypes.func.isRequired,
  onForward: PropTypes.func.isRequired
};
export default Navigation;

require("./navigation.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./navigation.js");